<script setup lang="ts">
  import { useCssModule } from 'vue';

  import useToasts from '../../composables/useToasts/useToasts';
  import Toast from '../Toast/Toast.vue';

  const toasts = useToasts();
  const classes = useCssModule();
</script>

<template>
  <TransitionGroup
    aria-atomic="true"
    aria-live="polite"
    name="toasts"
    tag="ul"
    :class="classes.root"
    class="stash-toasts"
    data-test="stash-toasts"
  >
    <Toast
      v-for="toast in toasts.active"
      :key="toast.id"
      :text="toast.text"
      :status="toast.status"
      :offset-top="toast.offsetTop"
      @click="toasts.remove(toast.id)"
    />
  </TransitionGroup>
</template>

<style module>
  @reference "../../../styles/main.css";

  .root {
    display: flex;
    flex-direction: column;
    position: fixed;
    min-width: 300px;
    max-width: calc(320px - --spacing(3));
    right: --spacing(6);
    top: 0;
    z-index: 1002;
    row-gap: --spacing(1.5);
  }
</style>

<style>
  .toasts-enter-active,
  .toasts-leave-active {
    transition: all 0.5s ease;
  }

  .toasts-enter-from,
  .toasts-leave-to {
    opacity: 0;
    transform: translateX(30px);
  }
</style>
